import { useCallback } from "react";
import { uploadValidator } from "../helpers/utils/uploadValidator";
import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { uploadValidatorSmallJpg } from "shared/helpers/utils/uploadValidatorSmallJpg";

const useUploadValidator = (onlyJpgFormat?: boolean, additionalValidate?: boolean ) => {
  const profile = useProfile();
  const toasts = useToasts();
  return useCallback((files: any) => {
    if (onlyJpgFormat) return uploadValidatorSmallJpg(files, toasts, false, profile)
    return uploadValidator(files, toasts, false, profile, additionalValidate)
  }, [profile])
}

export default useUploadValidator;import { useCallback } from "react";
import { uploadValidator } from "../helpers/utils/uploadValidator";
import { useProfile } from "@brg/auth";
import { useToasts } from "@brg/ui";
import { uploadValidatorSmallJpg } from "shared/helpers/utils/uploadValidatorSmallJpg";

const useUploadValidator = (onlyJpgFormat?: boolean, additionalValidate?: boolean ) => {
  const profile = useProfile();
  const toasts = useToasts();
  return useCallback((files: any) => {
    if (onlyJpgFormat) return uploadValidatorSmallJpg(files, toasts, false, profile)
    return uploadValidator(files, toasts, false, profile, additionalValidate)
  }, [profile])
}

export default useUploadValidator;